<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.75 1.83301H4.58333V20.1663H2.75V1.83301ZM9.16667 5.49967H15.5833V7.33301H9.16667V5.49967ZM9.16667 9.16634H15.5833V10.9997H9.16667V9.16634Z"
            fill="currentColor" fill-opacity="0.9" />
        <path
            d="M17.4167 1.83301H5.5V20.1663H17.4167C18.4278 20.1663 19.25 19.3441 19.25 18.333V3.66634C19.25 2.65526 18.4278 1.83301 17.4167 1.83301ZM17.4167 18.333H7.33333V3.66634H17.4167V18.333Z"
            fill="currentColor" fill-opacity="0.9" />
    </svg>

</template>